import { cdnPhotoUrl } from 'constants/common';

export const howToOrderItem = {
	title: 'Оформить шторы на заказ в магазине',
	contentItems: [
		'Перед приездом в магазин сделайте замеры окна.',
		'В магазине вместе с дизайнером выберите тип и цвет ткани и получите готовый дизайн-проект.',
	],
	buttonText: 'Выбрать ближайший магазин',
	imgAlt: 'Оформить шторы в магазине',
	imgUrls: {
		lDesk: `${cdnPhotoUrl}/instore/poshiv/poshiv_desktop.jpg/poshiv_desktop.jpg`,
		tab: `${cdnPhotoUrl}/instore/poshiv/poshiv_tablet.jpg/poshiv_tablet.jpg`,
		mob: `${cdnPhotoUrl}/instore/poshiv/poshiv_mob.jpg/poshiv_mob.jpg`,
	},
	dataQa: 'how-to-order-in-store',
};
